import { render, staticRenderFns } from "./SetWebsite.vue?vue&type=template&id=68639ec1&"
import script from "./SetWebsite.vue?vue&type=script&lang=js&"
export * from "./SetWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports